/**
 * snk.ts — Categoría "Snacks / Confitería" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_snk",
  skuPrefix: "SNK",
  categoria: "Snacks",
} as const;

export const cat_snk_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Papas Margarita Pollo 100g",
    marca: "Margarita",
    modelo: "Sabor Pollo",
    origen: "Colombia",
    costo: 2500,
    precio: 4500,
    stock: 180,
    stockMinimo: 40,
    stockMaximo: 350,
    unidad: "paquete",
    ubicacionFisica: "Góndola snacks A1",
    proveedor: "Colombina S.A.",
    vencimientoMeses: 6,
    pesoNeto: "100g",
    descripcionLarga:
      "Papas fritas artesanales sabor pollo Margarita. Empaque 100g ideal para compartir o lonchera.",
    especificaciones: [
      { clave: "Peso", valor: "100g" },
      { clave: "Sabor", valor: "Pollo" },
    ],
    imageKeywords: ["potato-chips", "margarita-chips", "snack-bag"],
    color: "bg-yellow-400",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Doritos Nacho 140g",
    marca: "Doritos",
    modelo: "Nacho",
    origen: "Colombia",
    costo: 4200,
    precio: 7500,
    stock: 150,
    stockMinimo: 30,
    stockMaximo: 300,
    unidad: "paquete",
    ubicacionFisica: "Góndola snacks A2",
    proveedor: "Frito-Lay Colombia",
    vencimientoMeses: 6,
    pesoNeto: "140g",
    descripcionLarga:
      "Tortillas crujientes sabor queso nacho. Empaque familiar 140g perfecto para fiestas y reuniones.",
    especificaciones: [
      { clave: "Peso", valor: "140g" },
      { clave: "Sabor", valor: "Queso Nacho" },
    ],
    imageKeywords: ["doritos", "tortilla-chips", "nacho-snack"],
    color: "bg-orange-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Cheetos Boliqueso 90g",
    marca: "Cheetos",
    modelo: "Boliqueso",
    origen: "Colombia",
    costo: 3200,
    precio: 5900,
    stock: 160,
    stockMinimo: 35,
    stockMaximo: 320,
    unidad: "paquete",
    ubicacionFisica: "Góndola snacks A2",
    proveedor: "Frito-Lay Colombia",
    vencimientoMeses: 6,
    pesoNeto: "90g",
    descripcionLarga:
      "Pasabocas sabor queso en forma de bolitas crujientes. Clásico sabor Cheetos favorito infantil.",
    especificaciones: [
      { clave: "Peso", valor: "90g" },
      { clave: "Formato", valor: "Bolitas" },
    ],
    imageKeywords: ["cheetos", "cheese-puffs", "crunchy-snack"],
    color: "bg-orange-400",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "De Todito Mix 150g",
    marca: "De Todito",
    origen: "Colombia",
    costo: 4800,
    precio: 8500,
    stock: 140,
    stockMinimo: 30,
    stockMaximo: 280,
    unidad: "paquete",
    ubicacionFisica: "Góndola snacks A3",
    proveedor: "Frito-Lay Colombia",
    vencimientoMeses: 6,
    pesoNeto: "150g",
    descripcionLarga:
      "Mezcla snacks surtidos: papas, plátanos, maíz y chicharrones. Presentación familiar 150g.",
    especificaciones: [
      { clave: "Peso", valor: "150g" },
      { clave: "Mezcla", valor: "4 snacks" },
    ],
    imageKeywords: ["mixed-snacks", "detodito", "snack-mix"],
    color: "bg-red-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Chocolatina Jet Display x24",
    marca: "Jet",
    modelo: "Chocolate con Leche",
    origen: "Colombia",
    costo: 16800,
    precio: 26900,
    stock: 60,
    stockMinimo: 15,
    stockMaximo: 120,
    unidad: "caja",
    ubicacionFisica: "Góndola dulces B1",
    proveedor: "Nutresa",
    vencimientoMeses: 9,
    pesoNeto: "288g (24x12g)",
    descripcionLarga:
      "Display 24 chocolatinas Jet con láminas coleccionables del álbum Jet. Clásico colombiano.",
    especificaciones: [
      { clave: "Unidades", valor: "24" },
      { clave: "Peso c/u", valor: "12g" },
    ],
    imageKeywords: ["chocolate-bar", "jet-chocolate", "colombian-candy"],
    color: "bg-amber-700",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Galleta Festival Chocolate x24",
    marca: "Noel",
    modelo: "Festival Chocolate",
    origen: "Colombia",
    costo: 12500,
    precio: 19900,
    stock: 80,
    stockMinimo: 18,
    stockMaximo: 160,
    unidad: "paquete",
    ubicacionFisica: "Góndola B2",
    proveedor: "Nutresa - Noel",
    vencimientoMeses: 8,
    pesoNeto: "403g (24x16.8g)",
    descripcionLarga:
      "Paquete 24 galletas Festival rellenas chocolate. Individuales empacadas ideal lonchera.",
    especificaciones: [
      { clave: "Unidades", valor: "24" },
      { clave: "Relleno", valor: "Chocolate" },
    ],
    imageKeywords: ["cookies", "festival-cookies", "chocolate-biscuits"],
    color: "bg-amber-800",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Bon Bon Bum Fresa x24",
    marca: "Colombina",
    modelo: "Fresa",
    origen: "Colombia",
    costo: 8500,
    precio: 13900,
    stock: 100,
    stockMinimo: 25,
    stockMaximo: 200,
    unidad: "paquete",
    ubicacionFisica: "Góndola B3",
    proveedor: "Colombina S.A.",
    vencimientoMeses: 18,
    pesoNeto: "432g (24x18g)",
    descripcionLarga:
      "Bolsa 24 chupetas Bon Bon Bum fresa con chicle adentro. Favorito tradicional Colombia.",
    especificaciones: [
      { clave: "Unidades", valor: "24" },
      { clave: "Sabor", valor: "Fresa" },
    ],
    imageKeywords: ["lollipop", "candy", "bon-bon-bum"],
    color: "bg-pink-500",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Trident Menta x12",
    marca: "Trident",
    modelo: "Menta Fresh",
    origen: "México",
    costo: 15800,
    precio: 24500,
    stock: 70,
    stockMinimo: 18,
    stockMaximo: 140,
    unidad: "display",
    ubicacionFisica: "Góndola caja C1",
    proveedor: "Mondelez Colombia",
    vencimientoMeses: 18,
    pesoNeto: "168g (12x14g)",
    descripcionLarga:
      "Display 12 paquetes chicles Trident menta sin azúcar. Protege esmalte dental, aliento fresco.",
    especificaciones: [
      { clave: "Unidades", valor: "12 paquetes" },
      { clave: "Azúcar", valor: "Sin azúcar" },
    ],
    imageKeywords: ["gum", "trident", "sugar-free-gum"],
    color: "bg-green-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Maní Japonés Jumbo 200g",
    marca: "Jumbo",
    origen: "Colombia",
    costo: 5800,
    precio: 9900,
    stock: 90,
    stockMinimo: 20,
    stockMaximo: 180,
    unidad: "paquete",
    ubicacionFisica: "Góndola snacks A4",
    proveedor: "Grupo Éxito",
    vencimientoMeses: 10,
    pesoNeto: "200g",
    descripcionLarga:
      "Maní estilo japonés cubierto masa harina tostada y soya. Crujiente, salado, ideal para cerveza.",
    especificaciones: [
      { clave: "Peso", valor: "200g" },
      { clave: "Tipo", valor: "Japonés" },
    ],
    imageKeywords: ["peanuts", "japanese-peanuts", "salted-snack"],
    color: "bg-yellow-700",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Trolli Gomitas ácidas 100g",
    marca: "Trolli",
    modelo: "Sour Brite Crawlers",
    origen: "Alemania",
    costo: 4200,
    precio: 7500,
    stock: 110,
    stockMinimo: 25,
    stockMaximo: 220,
    unidad: "paquete",
    ubicacionFisica: "Góndola B3",
    proveedor: "Mondelez",
    vencimientoMeses: 12,
    pesoNeto: "100g",
    descripcionLarga:
      "Gomitas ácidas Trolli sabor frutal. Textura masticable con cobertura ácida-dulce.",
    especificaciones: [
      { clave: "Peso", valor: "100g" },
      { clave: "Sabores", valor: "Frutales mixtos" },
    ],
    imageKeywords: ["gummy-candy", "sour-gummies", "trolli"],
    color: "bg-lime-400",
    shape: "square",
  }),
];
